// ============================================================
// ASSK Sangli Portal - mock/demo data (frontend-only)
// Replaceable by real API later.
// ============================================================

export const STEPS = [
  "वैयक्तिक माहिती",
  "शैक्षणिक माहिती",
  "संगणक साक्षरता",
  "पायाभूत सुविधा",
  "आर्थिक क्षमता",
  "अनुभव",
  "व्यवसाय आराखडा",
  "सामाजिक समावेशकता",
  "चारित्र्य पडताळणी",
  "अर्ज शुल्क",
  "कागदपत्रे",
  "पूर्वावलोकन",
];

// Devanagari numerals for step badges
export const DEVANAGARI = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९", "१०", "११", "१२"];

export const MARKS = {
  2: "(१० गुण)",
  3: "(१५ गुण)",
  4: "(१५ गुण)",
  5: "(१० गुण)",
  6: "(१० गुण)",
  7: "(५ गुण)",
  8: "(५ गुण)",
  9: "(१० गुण)",
};

// Taluka -> villages master data (Sangli district demo)
export const MASTER = {
  मिरज: ["मिरज", "आरग", "कवलापूर", "बुधगाव"],
  तासगाव: ["तासगाव", "सावळज", "मणेराजुरी", "येळावी"],
  वाळवा: ["इस्लामपूर", "आष्टा", "बागणी", "कासेगाव"],
  पलूस: ["पलूस", "कुंडल", "अंकलखोप", "भिलवडी"],
  शिराळा: ["शिराळा", "मांगले", "बांबवडे"],
  खानापूर: ["विटा", "भाळवणी", "रेणावी"],
};

export const INFRA_ITEMS = [
  { label: "कार्यालयाची जागा ही घर किंवा इतर वापरापासून स्वतंत्र आहे का?", qtyLabel: "तपशील" },
  { label: "कार्यालय खोलीचे क्षेत्रफळ चौ. फूट मधे", qtyLabel: "चौ. फूट" },
  { label: "किमान १०० चौ.फूट क्षेत्रफळाचे स्वतंत्र कार्यालय उपलब्ध असल्याबाबत ग्रामपंचायत ८-अ चा उतारा / नगरपंचायत किंवा नगरपरिषदेकडील असेसमेंट उतारा; जागा भाड्याची असल्यास भाडेकरार", qtyLabel: "तपशील" },
  { label: "दोन संगणक / लॅपटॉप", qtyLabel: "संख्या" },
  { label: "लेझर प्रिंटर", qtyLabel: "संख्या" },
  { label: "स्कॅनर", qtyLabel: "संख्या" },
  { label: "बायोमेट्रिक उपकरण", qtyLabel: "संख्या" },
  { label: "वेबकॅम", qtyLabel: "संख्या" },
  { label: "यूपीएस अथवा पर्यायी वीज बॅकअप", qtyLabel: "तपशील" },
  { label: "ब्रॉडबँड इंटरनेट (ग्रामीण १० Mbps, नागरी २० Mbps)", qtyLabel: "स्पीड (Mbps)" },
  { label: "सीसीटीव्ही व्यवस्था", qtyLabel: "संख्या" },
  { label: "दिव्यांग व ज्येष्ठ नागरिकांसाठी सुलभ प्रवेश", qtyLabel: "तपशील" },
  { label: "नागरिकांसाठी प्रतीक्षा कक्ष", qtyLabel: "तपशील" },
  { label: "शासनप्राधिकृत सेवा शुल्क दर्शविणारा फलक व बाह्य नामफलक", qtyLabel: "तपशील" },
];

// Step 8 - social inclusion questions
export const SOCIAL_ITEMS = [
  { key: "si_disabled", label: "दिव्यांग", note: "अर्जदार यांचे दिव्यांग असल्यास ४०% दिव्यांग असल्याबाबत UDID कार्ड *" },
  { key: "si_exservice", label: "माजी सैनिक", note: "अर्जदार यांचे माजी सैनिक असल्यास जिल्हा सैनिक कल्याण कार्यालयातील नोंदीची प्रत व डिसचार्ज बुक *" },
  { key: "si_shg", label: "स्वयंसहाय्यता गट सदस्य", note: "अर्जदार यांचे बचत गट/शेतकरी उत्पादक गट (FIG)/उमेद-NRLM गट सदस्य असल्यास गट नोंदणी प्रमाणपत्र, ठराव, बँक पासबुकची छायांकित प्रत ( तालुकास्तरीय विभाग प्रमुखांचे प्रमाणपत्र - गट विकास अधिकारी, तालुका कृषी अधिकारी *" },
  { key: "si_entrepreneur", label: "स्थानिक उद्योजक", note: "अर्जदार हे स्थानिक उद्योजक असल्यास, महाव्यवस्थापक जिल्हा उद्योग केंद्र यांचेकडील प्रमाणपत्र *" },
];

// Step 11 - required documents (14)
export const DOCS = [
  { label: "स्वघोषणापत्र", template: true },
  { label: "आधारकार्ड मूळ प्रत" },
  { label: "पॅनकार्ड मूळ प्रत" },
  { label: "स्थानिक रहिवासी पत्त्याचा पुरावा (तहसीलदार डोमासाईल प्रमाणपत्र / पासपोर्ट / वाहनचालक परवाना यापैकी कोणतीही एक प्रत बारकोड असणे गरजेचे आहे)" },
  { label: "अर्जदार यांचे कॉमन सर्व्हिस सेंटर (C.S.C.) प्रमाणपत्राची मूळ प्रत" },
  { label: "अर्जदार यांचे बँकिंग प्रतिनिधी असल्यास बँकिंग सेवा पुरविण्याबाबतचे मान्यताप्राप्त संस्थेने दिलेले प्रमाणपत्र/ओळखपत्र" },
  { label: "अर्जदार यांचे ई-गव्हर्नन्स किंवा तत्सम क्षेत्रातील अनुभव असल्यास नियुक्ती आदेश/अनुभव प्रमाणपत्र" },
  { label: "अर्जदार यांचे दिव्यांग असल्यास ४०% दिव्यांग असल्याबाबत UDID कार्ड" },
  { label: "अर्जदार यांचे माजी सैनिक असल्यास जिल्हा सैनिक कल्याण कार्यालयातील नोंदीची प्रत व डिसचार्ज बुक" },
  { label: "अर्जदार यांचे बचत गट/शेतकरी उत्पादक गट (FIG)/उमेद-NRLM गट सदस्य असल्यास गट नोंदणी प्रमाणपत्र, ठराव, बँक पासबुकची छायांकित प्रत ( तालुकास्तरीय विभाग प्रमुखांचे प्रमाणपत्र - गट विकास अधिकारी, तालुका कृषी अधिकारी" },
  { label: "अर्जदार हे स्थानिक उद्योजक असल्यास, महाव्यवस्थापक जिल्हा उद्योग केंद्र यांचेकडील प्रमाणपत्र" },
  { label: "नावात बदल झाला असल्यास दोन्ही नावाची व्यक्ती एकच असल्याबाबतचे गॅझेट / विवाहित स्त्री अर्जदारांच्या बाबतीत विवाह दाखला" },
  { label: "किमान १०० चौ.फूट क्षेत्रफळाचे स्वतंत्र कार्यालय उपलब्ध असल्याबाबत ग्रामपंचायत ८-अ चा उतारा / नगरपंचायत किंवा नगरपरिषदेकडील असेसमेंट उतारा; जागा भाड्याची असल्यास भाडेकरार" },
  { label: "फसवणूक, आर्थिक गैरव्यवहार किंवा शासकीय काळ्या यादीत नसणे प्रतिज्ञापत्र", template: true },
];

// Step 10 - bank / treasury details
export const BANK_DETAILS = {
  bankName: "Central Bank of India",
  accountName: "JILHA SETU SAMITEE",
  accountNo: "2097211017",
  ifsc: "CBIN0280699",
  branch: "अमरावती शाखा, अमरावती",
  address: "Amravati Branch, Amravati - 444601, Maharashtra",
  upiId: "",
  amount: 250,
};

export const PAYMENT_METHODS = ["UPI", "नेट बँकिंग", "बँक ट्रान्सफर"];

export const CRITERIA = {
  2: "किमान उच्च माध्यमिक शालांत परीक्षा (HSC) उत्तीर्ण; पदवी किंवा पदव्युत्तर पात्रतेस अतिरिक्त गुण (पदवी असल्यास २ अतिरिक्त गुण, पदव्युत्तर असल्यास ३ अतिरिक्त गुण).",
  3: "MSCIT किंवा समकक्ष प्रमाणपत्र, संगणक हाताळणी, ऑनलाइन अर्ज प्रक्रिया व सायबर सुरक्षा यांचे ज्ञान.",
  4: "स्वतंत्र कार्यालय, संगणक, प्रिंटर, स्कॅनर, बायोमेट्रिक उपकरण, इंटरनेट, वीज बॅकअप, सीसीटीव्ही, दिव्यांग व ज्येष्ठ नागरिकांसाठी सुलभ प्रवेश.",
  5: "आवश्यक गुंतवणूक करण्याची व किमान ६ ते १२ महिने व्यवसाय चालविण्याची आर्थिक क्षमता.",
};

// Header meta
export const HEADER = {
  govt: "महाराष्ट्र शासन · जिल्हाधिकारी कार्यालय, अमरावती",
  title: 'नवीन "आपले सरकार सेवा केंद्र" मिळणेकामी अर्जाचा नमुना',
  sub: "जाहिरनामा २०२६ · शासन निर्णय दि. ०९-०७-२०२६",
};

export const ORG_TYPES = ["-- निवडा --", "ग्रामपंचायत", "नगरपंचायत", "नगरपरिषद", "महानगरपालिका"];

export function newApplicationNumber() {
  return String(Math.floor(100000 + Math.random() * 900000));
}

// Tehsils (English value used for jurisdiction tagging) with Marathi labels — Amravati district
export const TEHSILS = [
  { value: "", label: "-- तहसील निवडा --" },
  { value: "Amravati", label: "अमरावती" },
  { value: "Bhatkuli", label: "भातकुली" },
  { value: "Nandgaon Khandeshwar", label: "नांदगाव खंडेश्वर" },
  { value: "Chandur Railway", label: "चांदूर रेल्वे" },
  { value: "Dhamangaon Railway", label: "धामणगाव रेल्वे" },
  { value: "Tiwsa", label: "तिवसा" },
  { value: "Morshi", label: "मोर्शी" },
  { value: "Warud", label: "वरुड" },
  { value: "Chandur Bazar", label: "चांदूर बाजार" },
  { value: "Achalpur", label: "अचलपूर" },
  { value: "Anjangaon Surji", label: "अंजनगाव सुर्जी" },
  { value: "Daryapur", label: "दर्यापूर" },
  { value: "Dharni", label: "धारणी" },
  { value: "Chikhaldara", label: "चिखलदरा" },
];
